import { Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ServicesPage from './pages/ServicesPage';
import ProjectsPage from './pages/ProjectsPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import QualityPolicy from './pages/QualityPolicy';
import QuickPaymentPage from './pages/QuickPaymentPage';
import PSDCTPage from './pages/Psdct';
import Terms from './pages/Terms';
import RegistrationPolicyPage from './pages/Registration-policy';
import CareersPage from './pages/Careers';
import Contact from './pages/Contact';
import FranchisePage from './pages/Franchise';
import Free from './pages/Free';
import StudentsPage from './pages/Students';
import Training from './pages/Training';
import Cancel from './pages/Cancel';
import RegisterPage from './pages/Register';
import CoursesPage from './pages/Courses';


function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/about" element={<AboutPage />} />
      <Route path="/services" element={<ServicesPage />} />
      <Route path="/projects" element={<ProjectsPage />} />
      <Route path="/privacy" element={<PrivacyPolicy />} />
      <Route path="/quality" element={<QualityPolicy />} />
      <Route path="/quick-payment" element={<QuickPaymentPage />} />
      <Route path="/psdct" element={<PSDCTPage />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/registration-policy" element={<RegistrationPolicyPage />} />
      <Route path="/careers" element={<CareersPage />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/franchise" element={<FranchisePage />} />
      <Route path="/free" element={<Free />} />
      <Route path="/students" element={<StudentsPage />} />
      <Route path="/training" element={<Training />} />
      <Route path="/cancel" element={<Cancel />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/courses" element={<CoursesPage />} />
    </Routes>
  );
}

export default App;
